import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const Available = () => {
  const { cityName } = useParams();
  return (
    <>
     <style jsx>{`
        /* Hero Section */
        .findacity-hero-section {
          display: flex;
          flex-direction: row;
          height: 500px;
          background-color: #fff;
          overflow: visible; /* Changed from hidden to visible to prevent cutting */
          position: relative;
        }

        .findacity-hero-content {
          flex: 1;
          padding: 50px 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: #fff;
          z-index: 1;
        }

        .findacity-hero-content h1 {
          font-size: 40px;
          line-height: 1.1;
          margin-bottom: 15px;
          font-weight: 700;
          margin-left: 10%;
        }

        .findacity-hero-content p {
          font-size: 18px;
          margin-bottom: 30px;
          color: #333;
          font-weight: 400;
          margin-left: 10%;
        }

        .findacity-signup-btn {
          background-color: #fd5c63;
          color: white;
          border: none;
          padding: 10px 25px;
          cursor: pointer;
          border-radius: 5px;
          text-transform: uppercase;
          margin-left: 10%;
          width: auto;
          font-family: 'sans-serif';
        }

        .findacity-signup-btn:hover {
          background-color: black;
        }

        .findacity-image-container {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: visible; /* Ensure the slanted image is not cut off */
          width: 100%; /* Ensure full width */
          padding-bottom: 20px; /* Add padding to accommodate the slant */
        }

      

        /* Responsive Design for Hero Section */
        @media (max-width: 768px) {
          .findacity-hero-section {
            flex-direction: column;
            text-align: center;
          }

          .findacity-hero-content {
            max-width: 100%;
            margin-bottom: 40px;
          }

          .findacity-image-container {
            width: 100%;
            height: auto;
          }

          .hero-Images {
            width: 110%;
            height: 400px;
            margin-left: -30px;
            object-fit: cover;
            transform: rotate(-5deg);
            margin-top: 15px;
            background-color: #FEF4F5;
          }
        }

        /* Place Container Section */
        .place-container {
          background-color: #FEF4F5;
          padding: 15% 20% 20% 20%;
          margin-top: -70px;
          text-align: center;
          clip-path: polygon(0 5%, 100% 0, 100% 100%, 0% 100%);
        }

        .place-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
          text-align: left;
        }

        .place-box {
          text-align: left;
          justify-content: left;
        }

        .place-box img.icon {
          width: 30px;
          height: 30px;
          margin-bottom: 20px;
        }

        .place-box h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .place-box p {
          font-size: 16px;
          color: #666;
        }

        .place-container h2 {
          font-size: 30px;
          margin-bottom: 20px;
          text-align: left;
        }

        .place-subtext {
          font-size: 18px;
          color: #666;
          margin-bottom: 40px;
          text-align: left;
        }

        .safety {
          display: block;
          color: #ff4f5a;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          margin-top: 30px;
          padding-left: 5px;
          transition: all 0.3s ease;
        }

        .safety:hover {
          color: #e0444d;
        }

  
    

       .driver-info-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 148px 5% 120px; /* increased top & bottom padding for more height */
  background-color: #fff5f5;
  clip-path: polygon(0 5%, 100% 0, 100% 100%, 0% 100%);
  margin-top: -197px;       /* move the section upward */
  margin-bottom: -5%;
  gap: 20px;
}



        .driver-info-left {
          flex: 1;
          max-width: 600px;
        }

        .driver-info-left h5 {
          font-size: 14px;
          text-transform: uppercase;
          color: #666;
          letter-spacing: 1px;
          margin-bottom: 12px;
          margin-left: 260px;
        }

        .driver-info-left h2 {
          font-size: 25px;
          color: #111;
          font-weight: bold;
          margin-bottom: 16px;
           margin-left: 260px;
        }

        .driver-info-left p {
          font-size: 16px;
          color: #444;
          line-height: 1.6;
          margin-bottom: 24px;
           margin-left: 260px;
        }

        .learn-more-link {
          color: #fd5c63;
          text-decoration: none;
          font-size: 16px;
          font-weight: 600;
        }

        .learn-more-link:hover {
          text-decoration: underline;
        }

        .driver-info-right {
          flex: 1;
          max-width: 500px;
          display: flex;
          flex-direction: column;
          gap: 30px;
          margin-right: 240px;
        }

        .driver-info-block h3 {
          font-size: 20px;
          color: #000;
          margin-bottom: 8px;
        }

        .driver-info-block p {
          font-size: 15px;
          color: #444;
          line-height: 1.6;
        }

    

        /* Place Section */
        .place-section {
          background-color: white;
          text-align: center;
          max-width: 100%;
          height: 80vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 1rem;
          clip-path: polygon(0 7%, 100% 0, 100% 100%, 0% 100%);
          margin-bottom: -5%;
        }

        .place-section h1 {
  font-size: 2rem;             /* or increase to 2.2rem for extra emphasis */
  color: #000;
  font-weight: 700;
  margin-bottom: 1rem;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  letter-spacing: -0.25px;
}

.place-section p {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.6;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

        .place-section a {
          text-decoration: none;
        }

        .placeride {
          background-color: #fd5c63;
          color: #fff;
          padding: 16px 32px;
          border: none;
          border-radius: 4px;
          font-size: 0.875rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          width: max-content;
          white-space: nowrap;
          text-align: center;
        }

        .placeride:hover {
          background-color: black;
        }
          .safetyy {
  display: block;
  margin: 50px auto;
 margin-left: 260px;
  color: #ff4d4f;
  font-size: 14px;
  text-decoration: none;
  
}
@media screen and (max-width: 768px) {
  .safetyy {
    display: block;
    margin: 20px 0 0 0;     /* Top margin only, remove left offset */
    text-align: left;
    color: #ff4d4f;
    font-size: 14px;
    text-decoration: none;
    margin-left: -50px;
  }
}
  @media (max-width: 768px) {
  .driver-info-section {
    flex-direction: column;
    align-items: flex-start;
    padding: 60px 45px;
    clip-path: none;
    margin-bottom: 0;
    gap: 40px;
    clip-path: polygon(0 4%, 100% 0, 100% 96%, 0% 100%);

    margin-top: -280px; /* Adjust value as needed */

  }

  .driver-info-left {
    max-width: 100%;
    margin: 0;
  }

  .driver-info-left h5,
  .driver-info-left h2,
  .driver-info-left p {
    margin-left: 0;
    text-align: left;
  }

  .safetyy {
    margin-left: 0;
    margin-top: 20px;
    text-align: left;
  }

  .driver-info-right {
    max-width: 100%;
    margin-right: 0;
  }

  .driver-info-block {
    margin-bottom: 20px;
  }

  .driver-info-block h3 {
    font-size: 18px;
  }

  .driver-info-block p {
    font-size: 15px;
  }
}

  
      `}</style>

      {/* JSX Component */}
      <div className="hero-sec">
        <div className="hero-text">
          <h1>We are in<br />{cityName.replace(/-/g, " ")}</h1>
          <p>Get free rides in {cityName.replace(/-/g, " ")}</p>
          <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">
            <button className="ride">Sign Up To Ride</button>
          </a>
        </div>
        
        <div className="all-images">
          <img src="/images/home.jpg" alt="Hero" className="hero-image"
           style={{  marginTop: 15 }} />
        </div>
      </div>

      <div className="berymo-containers">
        <h2>Why ride with Berymo Places</h2>
        <p className="berymo-subtexts">
          Berymo Places is the one and only free rideshare service that connects riders, drivers, and partner places. Pick one of our partner places on the app and request unlimited free rides.
        </p>
        <div className="berymo-grids">
          {[
            { img: "cash", title: "Save money", text: "Berymo Places is always free, saving you money so you can enjoy more of the moment at one of our partner places." },
            { img: "time", title: "Save time", text: "No need to spend your time searching for a place to park. Save time by requesting a free ride with Berymo Places." },
            { img: "friends", title: "Enjoy with friends", text: "Going out with friends or want an extra person to tag along for the ride? With Berymo Places, you can easily add a friend to join you." },
          ].map((item, i) => (
            <div className="place-box" key={i}>
              <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
        <Link to="/riderr" className="safety">learn more Berymo Places App → </Link>
      </div>

      <div className="place-image">
        <img src="/images/find-a-city.jpg" alt="ride" className="city-image" />
      </div>
      
      <div className="driver-info-section">
        <div className="driver-info-left">
          <h5>DRIVE WITH BERYMO</h5>
          <h2>Driving with Berymo is a great way to be your own boss</h2>
          <p>
            As a Berymo driver, you work on your own schedule. Earn extra cash whenever
            you want and wherever you are.
          </p>
          
        </div>

        <div className="driver-info-right">
          <div className="driver-info-block">
            <h3>Earn great money</h3>
            <p>
              Berymo drivers get paid per rider, making your income simple and transparent.
              As a driver for Berymo, you can make up to $35 an hour.
            </p>
          </div>

          <div className="driver-info-block">
            <h3>Less time, more riders</h3>
            <p>
              Drivers only operate within an 8 miles radius; maximizing the number of riders
              you transport while minimizing miles on your car and time spent driving.
            </p>
            <a href="#" className="safetyy" style={{marginLeft: '-580px'}}>
            Learn more about driving with Berymo →
          </a>
          </div>
        </div>
      </div>
      <div className="place-section">
        <h1>Earn great money on your schedule</h1>
        <p>Drive with Berymo and earn up to $1,800 for the first 60 loops you complete in your city.</p>
        <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1"> 
          <button className="ridee">Sign Up To Drive</button>
        </a> 
      </div>
    </>
  );
};

export default Available;